import React, {ReactNode} from 'react';
import {Breadcrumb as List, BreadcrumbItem as Item} from 'reactstrap';
import {Link} from 'react-router-dom';
import {BreadcrumbItem, BreadcrumbsProps} from '../../@types/components/Breadcrumbs';
import Translate from '../Translate/Translate';
import {getEndpointUri} from '../../helpers/getEndpointUri';
import {LayoutContext} from '../../contexts/LayoutContext';

export default class Breadcrumbs extends React.Component<BreadcrumbsProps & { hideBreadcrumbs?: boolean }> {
    static contextType = LayoutContext;
    context!: React.ContextType<typeof LayoutContext>;

    render() {
        const items = [this.getHomeItem(), ...this.getItems()];

        return <div className="breadcrumbs">
            <div>
                <Translate
                        message={this.props.pageTitle}
                        tag="h4"
                        className="mb-0 font-size-18"
                        replace={this.props.pageTitlesReplacers}
                />
                {this.props.pageSubTitle ? (
                        <Translate
                                message={this.props.pageSubTitle}
                                tag="h3"
                                className="mb-0 font-size-14"
                                replace={this.props.pageTitlesReplacers}
                        />
                ) : null}
            </div>

            {this.props.hideBreadcrumbs === true ? null : <div className="page-title-right">
                <List listClassName="m-0">
                    {items.map((item, i, list) => {
                        const isLast = i === list.length - 1;

                        return this.renderItem(item, i, isLast);
                    })}
                </List>
            </div>}
        </div>;
    }

    protected getHomeItem(): BreadcrumbItem {
        if (this.props.home) {
            return this.props.home;
        }

        return {
            icon: 'fas fa-home',
            uri: {
                route: 'index'
            }
        };
    }

    protected getItems(): BreadcrumbItem[] {
        const items = this.props.items;
        if (!items.length) {
            return [{
                label: this.props.pageTitle,
                uri: '#',
                isInteractive: false,
            }];
        }

        return items;
    }

    protected renderItem(item: BreadcrumbItem, index: number, isLastItem: boolean): ReactNode {
        const isInteractive = this.isInteractiveItem(item, isLastItem);

        return <Item key={`breadcrumb-${index}-item`}>
            {
                item.label ?
                        this.renderLink(item, isInteractive) :
                        this.renderIcon(item, isInteractive)
            }
        </Item>;
    }

    protected renderLink(item: BreadcrumbItem, isInteractive: boolean) {
        return <Link to={isInteractive ? getEndpointUri(item.uri) : '#'}>
            <Translate
                    message={item.label ?? ''}
                    replace={this.context.getPageMeta().pageTitlesReplacers}
            />
        </Link>;
    }

    protected renderIcon(item: BreadcrumbItem, isInteractive: boolean) {
        return <Link to={isInteractive ? getEndpointUri(item.uri) : '#'}>
            <i className={item.icon ?? ''}/>
        </Link>;
    }

    protected isInteractiveItem(item: BreadcrumbItem, isLastItem: boolean): boolean {
        if (item.isInteractive !== undefined) {
            return item.isInteractive;
        }

        if (!isLastItem) {
            return true;
        }

        return this.props.lastItemNotInteractive ?? false;
    }
}
